// where 절
const whereOperators = {
    isNull: 'isNull',
    isNotNull: 'isNotNull',
    equals: 'equals',
    notEquals: 'notEquals',
    greater: 'greater',
    lesser: 'lesser',
    greaterOrEquals: 'greaterOrEquals',
    lesserOrEquals: 'lesserOrEquals',
    like: 'like',
    notLike: 'notLike',
    between: 'between',
    include: 'include',
};
function compose(field, operator, ...data) {
    const value = data[0];
    if (!value && value !== 0) {
        return `${field}:${operator}`;
    }
    return `${field}:${operator}[${data.join(';')}]`;
}
function composeOr(field, operator, ...data) {
    return `${field}${operator}${data}`;
}
const isNull = (field) => compose(field, 'isNull');
const isNotNull = (field) => compose(field, 'isNotNull');
const equals = (field, ...data) => compose(field, 'eq', ...data);
const notEquals = (field, ...data) => compose(field, 'neq', ...data);
const greater = (field, ...data) => compose(field, 'gt', ...data);
const lesser = (field, ...data) => compose(field, 'lt', ...data);
const greaterOrEquals = (field, ...data) => compose(field, 'gte', ...data);
const lesserOrEquals = (field, ...data) => compose(field, 'lte', ...data);
const like = (field, ...data) => compose(field, 'like', ...data);
const notLike = (field, ...data) => compose(field, 'notLike', ...data);
const between = (data) => {
    const { field, start, end } = data;
    return compose(field, 'between', start, end);
};
const include = (field, ...data) => compose(field, 'in', ...data);
const or = '|';
const orOperator = (field, ...data) => composeOr(field, or, ...data);
// TODO 나중에 class 로 분리하는게 나을듯
const functionNameMapper = {
    isNull,
    isNotNull,
    equals,
    notEquals,
    greater,
    lesser,
    greaterOrEquals,
    lesserOrEquals,
    like,
    notLike,
    between,
    include,
    orOperator,
};
/**
 * 필터 추가 헬퍼
 * @param {QueryParameterBuilder} params
 * @param {Array} filters
 * @returns {QueryParameterBuilder}
 */
const injectFilterParamHelper = (params, filters = []) => {
    filters.forEach(({ condition, field, value }) => {
        if (!value) {
            return;
        }
        params.addFilters(
        // @ts-ignore
        functionNameMapper[condition](field, value));
    });
    return params;
};
export { whereOperators, isNull, isNotNull, equals, notEquals, greater, lesser, greaterOrEquals, lesserOrEquals, like, notLike, between, include, or, injectFilterParamHelper, orOperator, };
